export default __webpack_public_path__ + "static/media/egg-step2-video.cf3aa6b4.mp4";